import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

function LoadingSpinner({ message = 'Loading...' }) {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="200px"
        >
            <CircularProgress size={40} />
            <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 2 }}
            >
                {message}
            </Typography>
        </Box>
    );
}

export default LoadingSpinner; 